import { getConversationById } from '@app/helpers'
import { MessageItem } from '@app/models'

import { getUpdateAt } from '@lib/utils'

import { ChatState, SendMessageStartPayload } from '../types'

export const onSendMessageStart = (
  state: ChatState,
  payload: SendMessageStartPayload
): ChatState => {
  const {
    conversationId,
    body,
    fromParticipantId,
    uuid,
    attachments,
    suggestedActionId,
  } = payload

  const conversation = getConversationById(state.conversations, conversationId)
  if (!conversation) {
    return state
  }

  const nowDate = getUpdateAt()

  const newMessage: MessageItem = {
    content: { text: body },
    acsChatMessageId: uuid,
    fromParticipantId,
    uuid,
    id: 0,
    source: 'Chat',
    type: 'Html',
    sendStatus: 'Queued',
    creationDate: nowDate,
    updateDate: nowDate,
    state: 'Pending',
    attachments,
  }

  const suggestedActions = suggestedActionId
    ? conversation.suggestedActions?.map((action) =>
      action.id === suggestedActionId
        ? { ...action, status: 'Clicked', updateDate: nowDate }
        : action
    )
    : conversation.suggestedActions

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversationId]: {
        ...conversation,
        messages: [newMessage, ...conversation.messages],
        total: conversation.total + 1,
        updateDate: nowDate,
        suggestedActions,
      },
    },
  }
}
